import Api from 'utils/api';


const useVoyages = () => {
    return {
        getBL: Api.bl.getBLs,
        updateBL: Api.bl.updateBL,
        splitBL: Api.bl.splitBL,
        generateNumbers: Api.bl.generate,
        normalizeNumbers: Api.bl.normalize,

        getTypes: Api.bl.getTypes,
        createType: Api.bl.createType,
        updateType: Api.bl.updateType,
        deleteType: Api.bl.deleteType,
    }
};

export default useVoyages;
